import React, { Component } from "react";

// Catches rendering errors anywhere below it, so a bug in one screen shows a
// message with a way out instead of leaving the whole page blank.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error:", error, info && info.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <div role="alert" style={{ maxWidth: 480, margin: "72px auto", padding: "0 16px", textAlign: "center" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: 500, marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ lineHeight: 1.5, marginBottom: 24 }}>
          Please reload the page. If this keeps happening, go back to the home page and sign in again.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ background: "#BA1F00", color: "#FFF", border: "none", padding: "10px 20px", marginRight: 12, cursor: "pointer" }}
        >
          <span style={{ color: "#FFF" }}>Reload</span>
        </button>
        <a href="/" style={{ color: "#BA1F00", textDecoration: "underline" }}>Home page</a>
      </div>
    );
  }
}

export default ErrorBoundary;
